import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../axios";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [info, setInfo] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const messageRef = useRef(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setInfo("");
    const payload = { name, email, password, password_confirmation: passwordConfirmation };
    try {
      await axios.post("/register", payload);
      setIsError(false);
      setInfo("登録処理を受け付けました。ご登録のメールアドレスを確認してください。");
      setName("");
      setEmail("");
      setPassword("");
      setPasswordConfirmation("");
      messageRef.current?.scrollIntoView({ behavior: "smooth" });
    } catch (err) {
      setIsError(true);
      const msg = err.response?.data?.message || "通信エラーが発生しました。";
      setInfo(msg);
      messageRef.current?.scrollIntoView({ behavior: "smooth" });
    } finally {
      setLoading(false);
    }
  };

  const fieldStyle = {
    width: "100%",
    padding: "11px 14px",
    borderRadius: "8px",
    border: "1.5px solid #a7f3d0",
    fontSize: "1rem",
    boxSizing: "border-box",
    background: "#f9fafb",
    outline: "none",
    transition: "border-color 0.2s, background 0.2s",
  };
  const onFocus = (e) => { e.target.style.borderColor = "#10b981"; e.target.style.background = "#fff"; };
  const onBlur  = (e) => { e.target.style.borderColor = "#a7f3d0"; e.target.style.background = "#f9fafb"; };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        overflowY: "auto",
        background: "linear-gradient(180deg, #ecfdf5 0%, #f0fdf4 100%)",
        padding: "48px 16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      {/* ロゴ */}
      <div style={{ marginBottom: "28px", textAlign: "center" }}>
        <div
          style={{
            display: "inline-flex",
            borderRadius: "999px",
            overflow: "hidden",
            boxShadow: "0 4px 12px rgba(4,120,87,0.25)",
            marginBottom: "10px",
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        >
          <div
            style={{
              background: "#2C9736",
              padding: "9px 13px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src="/logo512.png"
              alt="BusWatch logo"
              style={{ width: 38, height: 38, display: "block", borderRadius: "50%" }}
            />
          </div>
          <div
            style={{
              background: "#d1fae5",
              padding: "9px 20px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span
              style={{
                fontSize: "21px",
                fontWeight: "800",
                color: "#047857",
                letterSpacing: "0.5px",
                whiteSpace: "nowrap",
              }}
            >
              西鉄バスWatch!
            </span>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            marginTop: "8px",
          }}
        >
          <span style={{ width: 24, height: 1, background: "#6ee7b7", borderRadius: 1 }} />
          <p
            style={{
              color: "#065f46",
              fontWeight: "600",
              fontSize: "13px",
              letterSpacing: "0.1em",
              margin: 0,
            }}
          >
            新規登録
          </p>
          <span style={{ width: 24, height: 1, background: "#6ee7b7", borderRadius: 1 }} />
        </div>
      </div>

      {/* カード */}
      <div
        style={{
          width: "100%",
          maxWidth: "420px",
          background: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 4px 24px rgba(4,120,87,0.10)",
          padding: "32px 28px",
          border: "1px solid #d1fae5",
          boxSizing: "border-box",
        }}
      >
        {info && (
          <div
            ref={messageRef}
            tabIndex={-1}
            style={{
              background: isError ? "#fee2e2" : "#d1fae5",
              color: isError ? "#b91c1c" : "#065f46",
              border: `1px solid ${isError ? "#fecaca" : "#6ee7b7"}`,
              borderRadius: "8px",
              padding: "10px 14px",
              fontSize: "0.875rem",
              marginBottom: "20px",
            }}
          >
            {info}
          </div>
        )}

        <form
          onSubmit={handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: "18px" }}
        >
          <div>
            <label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", marginBottom: "6px", color: "#065f46" }}>
              ハンドルネーム
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              placeholder="例：西鉄バス好き太郎"
              style={fieldStyle}
              onFocus={onFocus}
              onBlur={onBlur}
            />
          </div>

          <div>
            <label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", marginBottom: "6px", color: "#065f46" }}>
              メールアドレス
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="example@email.com"
              style={fieldStyle}
              onFocus={onFocus}
              onBlur={onBlur}
            />
          </div>

          <div>
            <label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", marginBottom: "6px", color: "#065f46" }}>
              パスワード
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
              style={fieldStyle}
              onFocus={onFocus}
              onBlur={onBlur}
            />
          </div>

          <div>
            <label style={{ display: "block", fontSize: "0.85rem", fontWeight: "600", marginBottom: "6px", color: "#065f46" }}>
              パスワード（確認）
            </label>
            <input
              type="password"
              value={passwordConfirmation}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
              required
              placeholder="••••••••"
              style={fieldStyle}
              onFocus={onFocus}
              onBlur={onBlur}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              padding: "13px",
              borderRadius: "10px",
              border: "none",
              background: loading ? "#6ee7b7" : "#10b981",
              color: "#fff",
              fontSize: "1rem",
              fontWeight: "700",
              cursor: loading ? "default" : "pointer",
              boxShadow: "0 2px 10px rgba(16,185,129,0.30)",
              transition: "background 0.2s",
              letterSpacing: "0.04em",
              marginTop: "4px",
            }}
            onMouseOver={(e) => { if (!loading) e.currentTarget.style.background = "#059669"; }}
            onMouseOut={(e) => { if (!loading) e.currentTarget.style.background = "#10b981"; }}
          >
            {loading ? "登録中…" : "登録する"}
          </button>
        </form>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            margin: "24px 0",
          }}
        >
          <span style={{ flex: 1, height: 1, background: "#d1fae5" }} />
          <span style={{ fontSize: "11px", color: "#a7f3d0", fontWeight: "600", letterSpacing: "0.05em" }}>
            OR
          </span>
          <span style={{ flex: 1, height: 1, background: "#d1fae5" }} />
        </div>

        <p style={{ textAlign: "center", fontSize: "0.875rem", color: "#065f46", margin: 0 }}>
          すでにアカウントをお持ちの方は{" "}
          <span
            onClick={() => navigate("/login")}
            style={{
              color: "#047857",
              fontWeight: "700",
              cursor: "pointer",
              textDecoration: "underline",
              textDecorationColor: "#6ee7b7",
              textUnderlineOffset: "3px",
            }}
          >
            ログインはこちら
          </span>
        </p>
      </div>
    </div>
  );
}
